
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PaymentService } from '../../api';
import { NotificationService } from '../../services/notification-service/notification.service';
import { Plan } from '../../components/payment-table/payment-table.component';
import { ConfirmPlanChangeComponent } from '../confirm-plan-change/confirm-plan-change.component';

@Component({
  selector: 'app-change-plan',
  templateUrl: './change-plan.component.html',
  styleUrl: './change-plan.component.scss'
})
export class ChangePlanComponent {
  isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { currentPlanLookupKey: string, currentPlanName: string } | string,
    public dialogRef: MatDialogRef<ChangePlanComponent>,
    private dialog: MatDialog,
    private paymentService: PaymentService,
    private notificationService: NotificationService,
  ) {}

  get currentPlanLookupKey(): string {
    return typeof this.data === 'string' ? this.data : this.data.currentPlanLookupKey;
  }

  get currentPlanName(): string {
    return typeof this.data === 'string' ? this.data : this.data.currentPlanName;
  }

  onPlanSelect(newPlan: Plan) {
    if (this.isLoading) return;

    const isPaidPlanChange = this.currentPlanLookupKey !== 'FREE' &&
                              this.currentPlanLookupKey !== newPlan.priceId;

    if (isPaidPlanChange) {
      const confirmDialog = this.dialog.open(ConfirmPlanChangeComponent, {
        data: {
          currentPlan: this.currentPlanName,
          newPlan: newPlan.name,
          isUpgrade: this.isUpgrade(newPlan.priceId)
        },
        width: '900px',
        maxWidth: '95vw'
      });

      confirmDialog.afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.executePlanChange(newPlan);
        }
      });
    } else {
      // Direkt ausführen für FREE-Wechsel oder neue Abos
      this.executePlanChange(newPlan);
    }
  }

  private isUpgrade(newPlanKey: string): boolean {
    const planOrder: { [key: string]: number } = {
      'FREE': 0,
      'BASIC': 1,
      'PRO': 2,
      'ENTERPRISE': 3
    };
    return planOrder[newPlanKey] > planOrder[this.currentPlanLookupKey];
  }

  private executePlanChange(plan: Plan) {
    this.isLoading = true;
    this.paymentService.changeSubscriptionEndpoint({
      newPlanLookupKey: plan.priceId,
      returnUrl: window.location.origin + '/organisation'
    }).subscribe({
      next: (response) => {
        if (response?.checkoutUrl) {
          window.location.href = response.checkoutUrl;
        } else {
          this.notificationService.showSuccess('Plan erfolgreich geändert');
          this.dialogRef.close(true);
          this.isLoading = false;
        }
      },
      error: () => {
        this.isLoading = false;
        this.notificationService.showError('Fehler beim Ändern des Plans');
      }
    });
  }
}